module.exports = __webpack_public_path__ + "img/tv_mini_gift_icon.275d3a34.svg";